module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/outgoing-mail-8134e009722be93d892bbfebf8655697.svg";